// extracted by mini-css-extract-plugin
module.exports = {"Form":"LoginForm_Form__2tE7a","Container":"LoginForm_Container__12TU5"};